interface VirtualRowBounds {
    /** Pixel offset of the row's top edge within the full list. */
    start: number;
    /** Pixel offset of the row's bottom edge within the full list. */
    end: number;
}

interface SpacerHeightsArgs {
    /** The rows the virtualiser currently wants rendered, in list order. */
    virtualRows: ReadonlyArray<VirtualRowBounds>;
    /** Height of the full list as if every row were rendered. */
    totalHeight: number;
}

interface SpacerHeights {
    /** Height standing in for the rows scrolled off above the rendered window. */
    topSpacerHeight: number;
    /** Height standing in for the rows still below the rendered window. */
    bottomSpacerHeight: number;
}

/**
 * Heights for the two spacers that keep virtualised rows in normal document flow, so the rows
 * stay free to size themselves horizontally instead of being absolutely positioned.
 */
const getSpacerHeights = ({
    virtualRows,
    totalHeight,
}: SpacerHeightsArgs): SpacerHeights => {
    const lastVirtualRow = virtualRows.at(-1);

    if (!lastVirtualRow) return { topSpacerHeight: 0, bottomSpacerHeight: 0 };

    return {
        topSpacerHeight: virtualRows[0].start,
        bottomSpacerHeight: totalHeight - lastVirtualRow.end,
    };
};

export { getSpacerHeights };
export type { SpacerHeights, VirtualRowBounds };
